<template>
  <div class="thank-you">
    <Header/>
    <Banner v-if="this.$route.name === 'thank-you-canberra'"
      image="hero-canberra@2x.jpg"
      alt=""
    />
    <Banner v-else
      image="hero-image@2x.jpg"
      alt=""
    />
    <!-- eslint-disable -->
    <div class="wrapper content">
      <div v-if="this.$route.name === 'thank-you-canberra'">
        <div class="wrapper content">
          <h1 class="title">You're in</h1>
          <p>We look forward to seeing you at Nike Canberra soon.</p>
        </div>
      </div>
      <div v-else>
          <h1 class="title">Thank You</h1>
          <div
            v-if="this.$route.name === 'thank-you-personalise'"
            class="content__text"
          >
            <p>
              Your {{getSelectedStoreName}} membership profile is complete! Enjoy 10% off* your next in-store Nike purchase, simply by presenting the most recent Nike membership email you received.
            </p>
            <p><strong>See you in-store.</strong></p>
          </div>
          <div
            v-else
            class="content__text"
          >
            <p>
              You're in! Stay tuned for the latest news, updates and offers from {{store}}.
            </p>
            <p><strong>See you in-store.</strong></p>
          </div>
        </div>
        <!-- eslint-enable -->
        <div
          v-if="this.$route.name === 'thank-you-personalise'"
          class="t-and-c"
        >
          *Some exclusions may apply. 10% off is only available at <router-link
            to="/participating-nike-stores"
            class="text__link"
            target="_blank">
          participating Nike stores</router-link>. Not available for purchases of gift vouchers. Cannot
          be used in conjunction with any other offer or purchases from Nike.com.
          Present the latest Nike membership email in-store to receive 10% off. 10%
          off can only be used for one transaction. Terms and conditions
          subject to change without notice.
        </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src

// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import Footer from '@/components/Footer.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'thankyou',
  props: ['store'],
  components: {
    Header,
    Banner,
    Footer,
  },
  computed: {
    ...mapGetters([
      'getSelectedStoreName',
    ]),
  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/settings.scss";

$content-width: 500px + $spacing-double;

.content {
  width: $content-width;
  text-align: center;
}

.content__text {
  margin-bottom: $spacing;
  line-height: 26px;

  p {
    margin-bottom: $spacing;
  }
}

.title {
  margin-bottom: $spacing-double;
}

.t-and-c {
  width: 980px;
  max-width: 100%;
  padding: 0 $spacing;
  margin: 30px auto $spacing-double;
  font-size: 12px;
  line-height: 1.8;
}
</style>
